import { reflect } from '@effector/reflect';
import { useUnit } from 'effector-react';
import { CircleSlash2 } from 'lucide-react';
import { equals, not } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { USER_ROLES } from 'shared/api';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { UnblockJackpotModel } from '../../model';

export const createUnblockJackpotModal = (model: UnblockJackpotModel) => {
	const ConfirmModal = createConfirmModal(model);

	const UnblockJackpotModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [jackpot] = useUnit([model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('unblock-jackpot.title')}
				cancelButtonProps={{
					children: t('unblock-jackpot.cancel'),
				}}
				submitButtonProps={{
					variant: 'outline',
					children: t('unblock-jackpot.unblock'),
				}}
				{...props}
			>
				{t('unblock-jackpot.description', {
					currency: jackpot?.currency,
					type: t(`jackpot-types.${jackpot?.type}`),
				})}
			</ConfirmModal>
		);
	});

	const UnblockJackpotModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'unblock-jackpot-action-icon',
			variant: 'ghost-destructive',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			children: <CircleSlash2 />,
		},
	});

	return Object.assign(UnblockJackpotModal, {
		ActionIcon: UnblockJackpotModalActionIcon,
	});
};
